import React from 'react';
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';

const axios = require('axios').default;
import TagManagerApp from '../../TagManager/startup/TagManagerApp';

const NoteAttachments = ({
  csrfToken,
  team,
  confirm,
  currentUser,
  openNote,
  openNoteChanged,
}) => (
  <div className="sl-note-attachments">
    <div className="sl-note-attachments-tags">
      <TagManagerApp
        csrfToken={csrfToken}
        team={team}
        currentUser={currentUser}
        scope="Note"
        title={`Tags`}
        taggable={openNote}
        tagsButtonPosition="left"
        activeTagsAlignment="left"
        popupClasses="px-0 col-12 col-md-4 col-lg-6 position-absolute shadow"
      />
    </div>
    <div className="sl-note-attachments-select">
      <AsyncSelect
        placeholder="Search to attach..."
        defaultOptions
        cacheOptions
        isMulti
        value={[
          ...(openNote.note_attachments || []),
          ...(openNote.note_attachments_attributes || [])
        ].map(na => ({
          value: na.attachable_id,
          label: na.label,
          attachable_type: na.attachable_type
        }))}
        loadOptions={(inputValue, callback) => {
          const debounced = _.debounce((q, cb) => {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
            axios.get(`/teams/${team.id}/calendar_events/${confirm.id}/grouped_note_attachables_index.json`)
              .then(({ data }) => {
                const groups = Object.keys(data || {}).map((groupKey) => {
                  const readable = groupKey.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
                  const attachableType = (groupKey === 'OFFERS') ? 'Offer' : groupKey.slice(0, -1).replace(/\b\w/g, c => c.toUpperCase());
                  return {
                    label: readable,
                    options: (data[groupKey] || []).map(opt => ({
                      ...opt,
                      attachable_type: attachableType
                    }))
                  };
                });

                const filterFn = (opt) => {
                  const label = opt.label || '';
                  return label.toLowerCase().includes((q || '').toLowerCase());
                };

                const filtered = groups.map(g => ({
                  ...g,
                  options: g.options.filter(filterFn)
                })).filter(g => g.options.length > 0);

                cb(filtered);
              });
          }, 250);

          return debounced(inputValue, callback);
        }}
        formatGroupLabel={data => (
          <div className="sl-note-attachments-group">
            <strong>{data.label}</strong>
          </div>
        )}
        getOptionLabel={option => option.label}
        getOptionValue={option => `${option.attachable_type}:${option.value}`}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderRadius: "8px",
            border: "1px solid var(--sl-border-primary)",
            backgroundColor: "var(--sl-bg-primary)",
          }),
          menu: (baseStyles) => ({
            ...baseStyles,
            width: "max-content",
            maxWidth: "500px",
            backgroundColor: "var(--sl-bg-primary)",
          }),
          option: (baseStyles, state) => ({
            ...baseStyles,
            color: "var(--sl-text-primary)",
            backgroundColor: state.isFocused ? "var(--sl-bg-secondary)" : "var(--sl-bg-primary)",
          }),
          multiValue: (styles, { index }) => {
            return index === 0 ? styles : {
              ...styles,
              ':before': {
                backgroundColor: 'var(--sl-bg-primary)',
                color: 'var(--sl-text-primary)',
                paddingLeft: '4px',
                paddingRight: '8px',
              }
            };
          }
        }}
        onChange={(options, actionMeta) => {
          if(actionMeta && actionMeta.action === 'select-option'){
            const option = actionMeta.option;
            if(!option){ return; }

            axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
            axios.post(`/teams/${team.id}/notes/${openNote.id}/note_attachments`, {
              note_attachment: {
                attachable_type: option.attachable_type,
                attachable_id: option.value
              }
            }).then(({ data }) => {
              const updated = Object.assign({}, openNote, {
                note_attachments: [
                  ...(openNote.note_attachments || []),
                  Object.assign({}, data)
                ]
              });
              openNoteChanged(updated);

              toast.success("Attached to note", {
                position: toast.POSITION.TOP_CENTER,
                draggable: false,
                closeOnClick: true,
                autoClose: 3000,
                hideProgressBar: true
              });
            }).catch((error) => {
              toast.error((error.response && error.response.data || []).join(", "), {
                position: toast.POSITION.TOP_CENTER,
                draggable: false,
                closeOnClick: false,
                autoClose: 5000,
                hideProgressBar: true
              });
            });
          } else if(actionMeta && actionMeta.action === 'remove-value'){
            const option = actionMeta.removedValue;
            if(!option){ return; }

            const existing = (openNote.note_attachments || []).find((e) => (
              e.attachable_type === option.attachable_type && e.attachable_id === option.value
            ));

            axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
            axios.delete(`/teams/${team.id}/notes/${openNote.id}/note_attachments/${existing.id}`)
              .then(() => {
                const updated = Object.assign({}, openNote, {
                  note_attachments: (openNote.note_attachments || []).filter((e) => e.id !== existing.id)
                });
                openNoteChanged(updated);

                toast.success("Removed from note", {
                  position: toast.POSITION.TOP_CENTER,
                  draggable: false,
                  closeOnClick: true,
                  autoClose: 3000,
                  hideProgressBar: true
                });
              });
          }
        }}
      />
    </div>
  </div>
);

export default NoteAttachments;
